<template>
  <div>
    <div class="title">{{ $t('web_accounn_center') }}</div>
    <div class="account-list">
      <AccountFunplus :info="bindInfo.funplus_id"></AccountFunplus>
      <AccountGoogle :info="bindInfo.google"></AccountGoogle>
      <AccountFacebook :info="bindInfo.facebook"></AccountFacebook>
    </div>
  </div>
</template>

<script>
import AccountFacebook from './AccountFacebook.vue'
import AccountGoogle from './AccountGoogle.vue'
import AccountFunplus from './AccountFunplus.vue'
export default {
  name: 'Account',
  components: { AccountFacebook, AccountGoogle, AccountFunplus },
  data () {
    return {
      bindInfo: JSON.parse(window.localStorage.getItem('sdkParams') || '{}').bindinfo
    }
  },
  methods: {},
  created () {
    this.$gtag.event('old_page2_account', {})
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
